import styled from 'styled-components'
import { space, fontSize, width, color, fontWeight } from 'styled-system'
import { lineHeight, textTransform, flexGrow, flexShrink } from './css'

const Link = styled.a`
  ${space} ${width} ${color} ${fontWeight} ${fontSize} ${lineHeight} ${textTransform} ${flexGrow} ${flexShrink};
`

export default Link
